"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * stripe/booking/v3/domain.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStripeBookingServiceApi = exports.PaymentStripeBookingServiceApiFactory = exports.PaymentStripeBookingServiceApiFp = exports.PaymentStripeBookingServiceApiAxiosParamCreator = exports.V1UsaState = exports.V1GuestProfileType = exports.V1DayTimePart = exports.V1Country = exports.V1CotOrBed = exports.Paymentv1PaymentMethod = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.Paymentv1PaymentMethod = {
    Unspecified: 'UNSPECIFIED',
    PayNow: 'PAY_NOW',
    PayLaterDelayedAuth: 'PAY_LATER_DELAYED_AUTH',
    PayLater: 'PAY_LATER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1CotOrBed = {
    CotBedNotSet: 'COT_BED_NOT_SET',
    Cot: 'COT',
    Bed: 'BED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1Country = {
    CountryNotSet: 'COUNTRY_NOT_SET',
    Af: 'AF',
    Al: 'AL',
    Dz: 'DZ',
    As: 'AS',
    Ad: 'AD',
    Ao: 'AO',
    Ai: 'AI',
    Aq: 'AQ',
    Ag: 'AG',
    Ar: 'AR',
    Am: 'AM',
    Aw: 'AW',
    Au: 'AU',
    At: 'AT',
    Az: 'AZ',
    Bs: 'BS',
    Bh: 'BH',
    Bd: 'BD',
    Bb: 'BB',
    By: 'BY',
    Be: 'BE',
    Bz: 'BZ',
    Bj: 'BJ',
    Bm: 'BM',
    Bt: 'BT',
    Bo: 'BO',
    Bq: 'BQ',
    Ba: 'BA',
    Bw: 'BW',
    Bv: 'BV',
    Br: 'BR',
    Io: 'IO',
    Bn: 'BN',
    Bg: 'BG',
    Bf: 'BF',
    Bi: 'BI',
    Kh: 'KH',
    Cm: 'CM',
    Ca: 'CA',
    Cv: 'CV',
    Ky: 'KY',
    Cf: 'CF',
    Td: 'TD',
    Cl: 'CL',
    Cn: 'CN',
    Cx: 'CX',
    Cc: 'CC',
    Co: 'CO',
    Km: 'KM',
    Cg: 'CG',
    Cd: 'CD',
    Ck: 'CK',
    Cr: 'CR',
    Ci: 'CI',
    Hr: 'HR',
    Cu: 'CU',
    Cw: 'CW',
    Cy: 'CY',
    Cz: 'CZ',
    Dk: 'DK',
    Dj: 'DJ',
    Dm: 'DM',
    Do: 'DO',
    Tp: 'TP',
    Ec: 'EC',
    Eg: 'EG',
    Sv: 'SV',
    Gq: 'GQ',
    Er: 'ER',
    Ee: 'EE',
    Et: 'ET',
    Fk: 'FK',
    Fo: 'FO',
    Fj: 'FJ',
    Fi: 'FI',
    Fr: 'FR',
    Fx: 'FX',
    Gf: 'GF',
    Pf: 'PF',
    Tf: 'TF',
    Ga: 'GA',
    Gm: 'GM',
    Ge: 'GE',
    De: 'DE',
    Gh: 'GH',
    Gi: 'GI',
    Gb: 'GB',
    Gr: 'GR',
    Gl: 'GL',
    Gd: 'GD',
    Gp: 'GP',
    Gu: 'GU',
    Gt: 'GT',
    Gn: 'GN',
    Gw: 'GW',
    Gy: 'GY',
    Ht: 'HT',
    Hm: 'HM',
    Hn: 'HN',
    Hk: 'HK',
    Hu: 'HU',
    Is: 'IS',
    In: 'IN',
    Id: 'ID',
    Ir: 'IR',
    Iq: 'IQ',
    Ie: 'IE',
    Im: 'IM',
    Il: 'IL',
    It: 'IT',
    Jm: 'JM',
    Jp: 'JP',
    Jo: 'JO',
    Kz: 'KZ',
    Ke: 'KE',
    Ki: 'KI',
    Kr: 'KR',
    Kp: 'KP',
    Kw: 'KW',
    Kg: 'KG',
    La: 'LA',
    Lv: 'LV',
    Lb: 'LB',
    Ls: 'LS',
    Lr: 'LR',
    Ly: 'LY',
    Li: 'LI',
    Lt: 'LT',
    Lu: 'LU',
    Mo: 'MO',
    Mk: 'MK',
    Mg: 'MG',
    Mw: 'MW',
    My: 'MY',
    Mv: 'MV',
    Ml: 'ML',
    Mt: 'MT',
    Mh: 'MH',
    Mq: 'MQ',
    Mr: 'MR',
    Mu: 'MU',
    Yt: 'YT',
    Mx: 'MX',
    Fm: 'FM',
    Mi: 'MI',
    Md: 'MD',
    Mc: 'MC',
    Mn: 'MN',
    Me: 'ME',
    Ms: 'MS',
    Ma: 'MA',
    Mz: 'MZ',
    Mm: 'MM',
    Na: 'NA',
    Nr: 'NR',
    Np: 'NP',
    Nl: 'NL',
    An: 'AN',
    Nc: 'NC',
    Nz: 'NZ',
    Ni: 'NI',
    Ne: 'NE',
    Ng: 'NG',
    Nu: 'NU',
    Nf: 'NF',
    Mp: 'MP',
    No: 'NO',
    Om: 'OM',
    Pk: 'PK',
    Pw: 'PW',
    Pa: 'PA',
    Pg: 'PG',
    Py: 'PY',
    Pe: 'PE',
    Ph: 'PH',
    Pn: 'PN',
    Pl: 'PL',
    Pt: 'PT',
    Pr: 'PR',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Ru: 'RU',
    Rq: 'RQ',
    Rw: 'RW',
    Sh: 'SH',
    Kn: 'KN',
    Lc: 'LC',
    Pm: 'PM',
    Vc: 'VC',
    Ws: 'WS',
    Sm: 'SM',
    St: 'ST',
    Sa: 'SA',
    Sn: 'SN',
    Rs: 'RS',
    Sc: 'SC',
    Sl: 'SL',
    Sg: 'SG',
    Sx: 'SX',
    Sk: 'SK',
    Si: 'SI',
    Sb: 'SB',
    So: 'SO',
    Za: 'ZA',
    Gs: 'GS',
    Ss: 'SS',
    Es: 'ES',
    Lk: 'LK',
    Sd: 'SD',
    Sr: 'SR',
    Sj: 'SJ',
    Sz: 'SZ',
    Se: 'SE',
    Ch: 'CH',
    Sy: 'SY',
    Tw: 'TW',
    Tj: 'TJ',
    Tz: 'TZ',
    Th: 'TH',
    Tg: 'TG',
    Tk: 'TK',
    To: 'TO',
    Tt: 'TT',
    Tn: 'TN',
    Tr: 'TR',
    Tm: 'TM',
    Tc: 'TC',
    Tv: 'TV',
    Uk: 'UK',
    Ug: 'UG',
    Ua: 'UA',
    Ae: 'AE',
    Us: 'US',
    Um: 'UM',
    Uy: 'UY',
    Uz: 'UZ',
    Vu: 'VU',
    Va: 'VA',
    Ve: 'VE',
    Vn: 'VN',
    Vg: 'VG',
    Vi: 'VI',
    Wf: 'WF',
    Eh: 'EH',
    Ye: 'YE',
    Zr: 'ZR',
    Zm: 'ZM',
    Zw: 'ZW'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1DayTimePart = {
    NotSet: 'NOT_SET',
    Hour0To1: 'HOUR_0_TO_1',
    Hour1To2: 'HOUR_1_TO_2',
    Hour2To3: 'HOUR_2_TO_3',
    Hour3To4: 'HOUR_3_TO_4',
    Hour4To5: 'HOUR_4_TO_5',
    Hour5To6: 'HOUR_5_TO_6',
    Hour6To7: 'HOUR_6_TO_7',
    Hour7To8: 'HOUR_7_TO_8',
    Hour8To9: 'HOUR_8_TO_9',
    Hour9To10: 'HOUR_9_TO_10',
    Hour10To11: 'HOUR_10_TO_11',
    Hour11To12: 'HOUR_11_TO_12',
    Hour12To13: 'HOUR_12_TO_13',
    Hour13To14: 'HOUR_13_TO_14',
    Hour14To15: 'HOUR_14_TO_15',
    Hour15To16: 'HOUR_15_TO_16',
    Hour16To17: 'HOUR_16_TO_17',
    Hour17To18: 'HOUR_17_TO_18',
    Hour18To19: 'HOUR_18_TO_19',
    Hour19To20: 'HOUR_19_TO_20',
    Hour20To21: 'HOUR_20_TO_21',
    Hour21To22: 'HOUR_21_TO_22',
    Hour22To23: 'HOUR_22_TO_23',
    Hour23To24: 'HOUR_23_TO_24'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1GuestProfileType = {
    Unspecified: 'GUEST_PROFILE_TYPE_UNSPECIFIED',
    Guest: 'GUEST_PROFILE_TYPE_GUEST',
    Billing: 'GUEST_PROFILE_TYPE_BILLING'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1UsaState = {
    UsaStateNotSet: 'USA_STATE_NOT_SET',
    Ak: 'AK',
    Al: 'AL',
    Ar: 'AR',
    As: 'AS',
    Az: 'AZ',
    Ca: 'CA',
    Co: 'CO',
    Ct: 'CT',
    Dc: 'DC',
    De: 'DE',
    Fl: 'FL',
    Fm: 'FM',
    Ga: 'GA',
    Gu: 'GU',
    Hi: 'HI',
    Ia: 'IA',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Ma: 'MA',
    Md: 'MD',
    Me: 'ME',
    Mh: 'MH',
    Mi: 'MI',
    Mn: 'MN',
    Mo: 'MO',
    Mp: 'MP',
    Ms: 'MS',
    Mt: 'MT',
    Nc: 'NC',
    Nd: 'ND',
    Ne: 'NE',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Nv: 'NV',
    Ny: 'NY',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pa: 'PA',
    Pr: 'PR',
    Pw: 'PW',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Va: 'VA',
    Vi: 'VI',
    Vt: 'VT',
    Wa: 'WA',
    Wi: 'WI',
    Wv: 'WV',
    Wy: 'WY'
};
/**
 * PaymentStripeBookingServiceApi - axios parameter creator
 * @export
 */
const PaymentStripeBookingServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {V3CancelIntentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServiceCancelIntent: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('paymentStripeBookingServiceCancelIntent', 'body', body);
            const localVarPath = `/stripe.booking.v3.PaymentStripeBookingService/CancelIntent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary non-REST
         * @param {V3GetIntentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServiceGetIntent: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('paymentStripeBookingServiceGetIntent', 'body', body);
            const localVarPath = `/stripe.booking.v3.PaymentStripeBookingService/GetIntent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V3PayLaterPenaltyChargeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServicePayLaterPenaltyCharge: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('paymentStripeBookingServicePayLaterPenaltyCharge', 'body', body);
            const localVarPath = `/stripe.booking.v3.PaymentStripeBookingService/PayLaterPenaltyCharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V3PayNowRefundRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServicePayNowRefund: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('paymentStripeBookingServicePayNowRefund', 'body', body);
            const localVarPath = `/stripe.booking.v3.PaymentStripeBookingService/PayNowRefund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V3RefundRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServiceRefund: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('paymentStripeBookingServiceRefund', 'body', body);
            const localVarPath = `/stripe.booking.v3.PaymentStripeBookingService/Refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PrePayment is used to setup necessary PaymentIntent or SetupIntent with Stripe depending on how the UI should handle taking payment - i.e. immediately or later. Our payment journeys cannot proceed without making this request first.
         * @param {V3PrePaymentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prePayment: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('prePayment', 'body', body);
            const localVarPath = `/stripe.booking.v3.PaymentStripeBookingService/PrePayment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentStripeBookingServiceApiAxiosParamCreator = PaymentStripeBookingServiceApiAxiosParamCreator;
/**
 * PaymentStripeBookingServiceApi - functional programming interface
 * @export
 */
const PaymentStripeBookingServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PaymentStripeBookingServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {V3CancelIntentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentStripeBookingServiceCancelIntent(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentStripeBookingServiceCancelIntent(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary non-REST
         * @param {V3GetIntentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentStripeBookingServiceGetIntent(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentStripeBookingServiceGetIntent(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V3PayLaterPenaltyChargeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentStripeBookingServicePayLaterPenaltyCharge(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentStripeBookingServicePayLaterPenaltyCharge(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V3PayNowRefundRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentStripeBookingServicePayNowRefund(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentStripeBookingServicePayNowRefund(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V3RefundRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentStripeBookingServiceRefund(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentStripeBookingServiceRefund(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary PrePayment is used to setup necessary PaymentIntent or SetupIntent with Stripe depending on how the UI should handle taking payment - i.e. immediately or later. Our payment journeys cannot proceed without making this request first.
         * @param {V3PrePaymentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prePayment(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prePayment(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.PaymentStripeBookingServiceApiFp = PaymentStripeBookingServiceApiFp;
/**
 * PaymentStripeBookingServiceApi - factory interface
 * @export
 */
const PaymentStripeBookingServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PaymentStripeBookingServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {V3CancelIntentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServiceCancelIntent(body, options) {
            return localVarFp.paymentStripeBookingServiceCancelIntent(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary non-REST
         * @param {V3GetIntentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServiceGetIntent(body, options) {
            return localVarFp.paymentStripeBookingServiceGetIntent(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V3PayLaterPenaltyChargeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServicePayLaterPenaltyCharge(body, options) {
            return localVarFp.paymentStripeBookingServicePayLaterPenaltyCharge(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V3PayNowRefundRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServicePayNowRefund(body, options) {
            return localVarFp.paymentStripeBookingServicePayNowRefund(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V3RefundRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentStripeBookingServiceRefund(body, options) {
            return localVarFp.paymentStripeBookingServiceRefund(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PrePayment is used to setup necessary PaymentIntent or SetupIntent with Stripe depending on how the UI should handle taking payment - i.e. immediately or later. Our payment journeys cannot proceed without making this request first.
         * @param {V3PrePaymentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prePayment(body, options) {
            return localVarFp.prePayment(body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PaymentStripeBookingServiceApiFactory = PaymentStripeBookingServiceApiFactory;
/**
 * PaymentStripeBookingServiceApi - object-oriented interface
 * @export
 * @class PaymentStripeBookingServiceApi
 * @extends {BaseAPI}
 */
class PaymentStripeBookingServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {V3CancelIntentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentStripeBookingServiceApi
     */
    paymentStripeBookingServiceCancelIntent(body, options) {
        return (0, exports.PaymentStripeBookingServiceApiFp)(this.configuration).paymentStripeBookingServiceCancelIntent(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary non-REST
     * @param {V3GetIntentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentStripeBookingServiceApi
     */
    paymentStripeBookingServiceGetIntent(body, options) {
        return (0, exports.PaymentStripeBookingServiceApiFp)(this.configuration).paymentStripeBookingServiceGetIntent(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V3PayLaterPenaltyChargeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentStripeBookingServiceApi
     */
    paymentStripeBookingServicePayLaterPenaltyCharge(body, options) {
        return (0, exports.PaymentStripeBookingServiceApiFp)(this.configuration).paymentStripeBookingServicePayLaterPenaltyCharge(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V3PayNowRefundRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentStripeBookingServiceApi
     */
    paymentStripeBookingServicePayNowRefund(body, options) {
        return (0, exports.PaymentStripeBookingServiceApiFp)(this.configuration).paymentStripeBookingServicePayNowRefund(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V3RefundRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentStripeBookingServiceApi
     */
    paymentStripeBookingServiceRefund(body, options) {
        return (0, exports.PaymentStripeBookingServiceApiFp)(this.configuration).paymentStripeBookingServiceRefund(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PrePayment is used to setup necessary PaymentIntent or SetupIntent with Stripe depending on how the UI should handle taking payment - i.e. immediately or later. Our payment journeys cannot proceed without making this request first.
     * @param {V3PrePaymentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentStripeBookingServiceApi
     */
    prePayment(body, options) {
        return (0, exports.PaymentStripeBookingServiceApiFp)(this.configuration).prePayment(body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentStripeBookingServiceApi = PaymentStripeBookingServiceApi;
